import { show as showNiceModal } from '@ebay/nice-modal-react'
import EulaDailog from '../EULAModal/EulaDailog'

const Footer = () => {
  return (
    <footer
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: '#fff',
        borderTop: '1px solid #ddd',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '8px 20px',
        fontSize: '14px',
        zIndex: 1000,
      }}
    >
      <span
        onClick={() => showNiceModal(EulaDailog)}
        style={{
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        End User License Agreement
      </span>
    </footer>
  )
}

export default Footer
